import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import Cookies from 'js-cookie';
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
    Sales: [],
    category: [],
    subCategory: [],
    products: [],
    Bom: [],
    Terms: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getSales = createAsyncThunk(
    'Sales/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/allSales', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data);
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getSalesById = createAsyncThunk(
    'SalesById/get',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getSalesById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.sales;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const addSales = createAsyncThunk(
    'Sales/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createSales', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getSales());
            return response.data.sales;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteSales = createAsyncThunk(
    'Sales/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteSales/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);



export const editSales = createAsyncThunk(
    'Sales/edit',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log("data", data);
        try {
            const { _id, ...rest } = data;
            // console.log(data);
            const response = await axiosInstance.put(`${BASE_URL}/updateSales/${_id}`, rest, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getSales());
            return response.data.sales;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const getcategorySales = createAsyncThunk(
    'categorySales/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getsalesCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getsubcategorySales = createAsyncThunk(
    'subcategorySales/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getsalesSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getproductSales = createAsyncThunk(
    'productSales/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getsalesProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getBomSales = createAsyncThunk(
    'BomSales/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getsalesBom', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.Bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const gettermsSales = createAsyncThunk(
    'termsSales/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getsalesTerms', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.Terms;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getBomSales1 = createAsyncThunk(
    'Bom/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/allBillOfMaterialSales', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getBomByIdSales = createAsyncThunk(
    'BomById/get',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getBomByIdSales/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data);
            dispatch(getBomSales1());
            return response.data.bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);




const SalesSlice = createSlice({
    name: 'Sales',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSales.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(getSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.Sales = action.payload.sales;
                state.allSalesCount = action.payload.allSalesCount
            })
            .addCase(getSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
            .addCase(addSales.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Sales...';
            })
            .addCase(addSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Sales?.push(action.payload);
                state.message = action.payload?.message || 'Sales added successfully';
            })
            .addCase(addSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Sales';
            })
            .addCase(deleteSales.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Sales...';
            })
            .addCase(deleteSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Sales = state.Sales.filter((Sales) => Sales._id !== action.payload);
                state.message = action.payload?.message || 'Sales deleted successfully';
            })
            .addCase(deleteSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Sales';
            })
            .addCase(editSales.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Sales...';
            })
            .addCase(editSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Sales = state.Sales.map((Sales) =>
                    Sales._id === action.payload._id ? action.payload : Sales
                );
                state.message = action.payload?.message || 'Sales updated successfully';
            })
            .addCase(editSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Sales';
            })
            .addCase(getSalesById.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(getSalesById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.Sales = action.payload;
            })
            .addCase(getSalesById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
            .addCase(getcategorySales.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(getcategorySales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.category = action.payload;
            })
            .addCase(getcategorySales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
            .addCase(getsubcategorySales.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(getsubcategorySales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.subCategory = action.payload;
            })
            .addCase(getsubcategorySales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
            .addCase(getproductSales.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(getproductSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.products = action.payload;
            })
            .addCase(getproductSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
            .addCase(getBomSales.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(getBomSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.Bom = action.payload;
            })
            .addCase(getBomSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
            .addCase(gettermsSales.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Sales...';
            })
            .addCase(gettermsSales.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Sales fetched successfully';
                state.Terms = action.payload;
            })
            .addCase(gettermsSales.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Sales';
            })
    }
});

export default SalesSlice.reducer;